import { render } from "./Referral.vue?vue&type=template&id=59cd9b75&scoped=true"
import script from "./Referral.vue?vue&type=script&lang=js"
export * from "./Referral.vue?vue&type=script&lang=js"

import "./Referral.vue?vue&type=style&index=0&id=59cd9b75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cd9b75"]])

export default __exports__